import * as z from 'zod'

const stringRequired = (message: string) => z.string({ required_error: message }).min(1, message)
const customerAccountValidation = stringRequired('Customer account is required!')

export const customerAddressSchema = z
  .object({
    id: z.string().optional().nullable(),
    addressType: z
      .object({ id: z.number(), name: z.string(), value: z.string() })
      .optional()
      .nullable(),
    line1: z.string().optional().nullable(),
    line2: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    region: z.string().optional().nullable(),
    postCode: z.string().optional().nullable(),
    country: z.string().optional().nullable(),
    location: z
      .object({ id: z.number(), name: z.string(), value: z.string() })
      .optional()
      .nullable()
  })
  .array()

export const customerSchema = z.object({
  id: z.string().optional().nullable(),
  businessName: stringRequired('Business name is required!'),
  salesContactEmail: stringRequired('Sales Contact Email email is required!').email(
    'Please enter a valid email!'
  ),
  customerAccountReference: customerAccountValidation,
  isActive: z.boolean().default(true),
  salesContactName: stringRequired('Sales Contact Name contact is required!'),
  salesContactTelephone: stringRequired('Sales Contact landline is required!'),
  salesContactMobile: z.string().optional().nullable(),
  // discountPercentage: z.number({ required_error: "Discount amount is required!", invalid_type_error: "Discount amount is required!" }).max(100, "Discount amount cannot be more than 100!"),
  addresses: customerAddressSchema.optional().nullable()
})
